import styled from 'styled-components';

export const $ModalContent = styled('div')`
  margin-top: 1.5rem;
  margin-right: auto;
  margin-left: auto;
`;
